import React from "react";
import {SettingsRowValue} from "../../common/CustomTable/CustomTable";
import {useTranslation} from "react-i18next";
import Collapsable from "../../common/Collapsable/Collapsable";

function DiscoverServiceSettings(props) {
    const {t} = useTranslation(['thirdPartyService']);
    const {
        thirdPartyService,
        style,
        isDisabled
    } = props;

    return (
        <Collapsable label={t('thirdPartyService:label.discoverSettings')}
            style={style} isDisabled={isDisabled}
        >
            <div className="settings-table">
                <div className="table-row-group">
                    <SettingsRowValue label={t('thirdPartyService:label.hostname')}
                        value={thirdPartyService.hostname} isDisabled={isDisabled}/>
                </div>
            </div>
        </Collapsable>
    )
}

export default DiscoverServiceSettings;
